import Backend from 'App/Dataman-Backend';

const { apiUrlComments } = Backend.config;

export const COMMENTS_PATHS = {
  comments: apiUrlComments,
};
